import { paths } from '@/core/router/paths';

export const getIsOnAuth2Path = (pathname: string) => {
	switch (pathname) {
		case paths.login:
		case paths.magicLinkVerification:
		case `${paths.login}/`:
		case `${paths.magicLinkVerification}/`:
			return true;
		default:
			return false;
	}
};
